import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { countriesActions } from "./countries.actions";

export const COUNTRIES_FEATURE_KEY = "countries";

export interface Country {
  uid: string;
  displayText: string;
  officialName: string;
  alpha2Code: string;
  alpha3Code: string;
  numericCode: string;
  dialCode: string;
  code: string;
  templateCode: {
    entityName: string;
    code: string;
    templateCode: string;
    displayText: string;
    type: string;
    subtype: string;
    method: string;
    submethod: string;
    classification: any;
  };
  type: string;
  subtype: string;
  method: string;
  submethod: string;
  currencyISOCode: string;
  languageName: string;
}

export interface CountriesState {
  countries: Country[];
  loading: boolean;
  error: string | null;
}

export const initialCountriesState: CountriesState = {
  countries: [],
  loading: false,
  error: null,
};

export const countriesSlice = createSlice({
  name: COUNTRIES_FEATURE_KEY,
  initialState: initialCountriesState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(countriesActions.fetchCountries.pending, (state: CountriesState) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(countriesActions.fetchCountries.fulfilled, (state: CountriesState, action: PayloadAction<Country[]>) => {
      state.loading = false;
      state.countries = action.payload;
    });
    builder.addCase(countriesActions.fetchCountries.rejected, (state: CountriesState, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to fetch countries";
    });
  },
});

export const countriesReducer = countriesSlice.reducer;
